module.exports = "/dist/16521668f5f238098329cdd7d27c391e.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-300italic.woff
// module id = 118
// module chunks = 0